const app = require('../app.js');
const CoachesView = require('../views/coaches.js');

const executeCoaches = function(clientToken, clubId, coachId) {
  app.rootView.showChildView(
    'content',
    new CoachesView({
      params: { clientToken, clubId, coachId }
    })
  );
};

app.router.route(':clientToken/clubs/:clubId/coaches', (clientToken, clubId) => {
  executeCoaches(clientToken, clubId);
});

app.router.route(':clientToken/clubs/:clubId/coaches/:coachId', (clientToken, clubId, coachId) => {
  executeCoaches(clientToken, clubId, coachId);
});

module.exports = function(clientToken, clubId, options) {
  const url = app.router.generate(':clientToken/clubs/:clubId/coaches', {
    clientToken,
    clubId
  });
  app.router.navigate(url, options);

  executeCoaches(clientToken, clubId);
};



// WEBPACK FOOTER //
// ./src/commands/goto-coach.js